import { useCreateCtx } from '@cleartax/wg-library-hooks';
import { UserContext } from './user.type';
// eslint-disable-next-line react-hooks/rules-of-hooks
export const [useUserCtx, UserProvider] = useCreateCtx<UserContext>();
